import { useEffect, useRef } from 'react';
import { useGoogleOAuth } from '@react-oauth/google';

type CredentialCb = (r: { credential?: string }) => void;

// google.accounts.id.initialize() solo debe llamarse una vez por carga de página
// (re-montar el componente no vuelve a inicializar). El callback vigente se
// guarda a nivel de módulo para que siempre apunte al handler del render actual.
let initialized = false;
let currentCb: CredentialCb | null = null;

function gsi(): any {
  return (window as any).google?.accounts?.id;
}

/** Olvida la cuenta auto-seleccionada para permitir elegir otra. */
export function googleDisableAutoSelect(): void {
  try { gsi()?.disableAutoSelect(); } catch { /* ignore */ }
}

interface Props {
  onCredential: CredentialCb;
  locale: string;
  /** Cambiarlo fuerza a re-renderizar el botón de Google. */
  renderKey?: number;
}

export function GoogleSignInButton({ onCredential, locale, renderKey = 0 }: Props) {
  const { clientId, scriptLoadedSuccessfully } = useGoogleOAuth();
  const ref = useRef<HTMLDivElement>(null);
  currentCb = onCredential;

  useEffect(() => {
    const id = gsi();
    if (!scriptLoadedSuccessfully || !id || !ref.current) return;
    if (!initialized) {
      id.initialize({ client_id: clientId, callback: (r: { credential?: string }) => currentCb?.(r) });
      initialized = true;
    }
    ref.current.innerHTML = '';
    id.renderButton(ref.current, { type: 'standard', locale: locale === 'zh' ? 'zh-CN' : locale });
  }, [scriptLoadedSuccessfully, clientId, locale, renderKey]);

  return <div ref={ref} data-testid="google-signin" />;
}
